<template>
  <ul class="sidebar navbar-nav">
    <li class="nav-item" :class="{ active: index == 1}">
      <router-link class="nav-link" to="/qtake_booking" v-if="qtake_read">
       <i class="fas fa-calendar-check"></i>
        <span>Booking</span>
      </router-link>
    </li>
    <li class="nav-item" :class="{ active: index == 2}" v-if="house_read">
      <router-link class="nav-link" to="/qtake_department">
        <i class="fas fa-cogs"></i>
        <span>Company</span>
      </router-link>
    </li>
    <li class="nav-item" :class="{ active: index == 3}" v-if="qtake_price">
      <router-link class="nav-link" to="/qtake_price">
        <i class="fas fa-tag"></i>
        <span>Price</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "QtakeSideBar",
  props: ["index"],
  computed: {
    qtake_read() {
      return this.$store.getters.hasPermission("qtake_read");
    },
    house_read() {
      return this.$store.getters.hasPermission("house_read");
    },
    qtake_price() {
      return this.$store.getters.hasPermission("qtake_price");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
